<!--
  添加银行卡
-->
<template>
  <div>
    <title-header title='添加银行卡'></title-header>
    <van-field v-model="name" label="持卡人" />
    <van-field v-model="cardNumber" label="卡号" @input='changeNum' :error-message='errorMessage' />
    <div v-show='display.showBankMeg'>
      <van-field v-model="cardMes.bankname" readonly label="发卡行" />
      <van-field v-model="cardMes.bankType" readonly label="银行卡类别" />
      <van-field v-model="subbranch" label="支行" placeholder="请填写支行名称" />
      <van-field v-model="bankAddress" label="开户行地址" placeholder="请填写开户行地址" />
    </div>
    <div class="add-card-btn-box">
      <van-button style="width: 35vw;" :disabled='!display.showBankMeg'  color='#45C5DA' @click="addCard">添加</van-button>
    </div>
  </div>
</template>
<script>
  import { debounce } from 'common/js/utils';
  import axios from 'axios';
  import api from 'api/wallet';
  import { bankname, cardTypeMap } from 'common/js/bankname';
import { Toast } from 'vant';
  export default {
    data() {
      return {
        display: {
          showBankMeg: false,//显示银行信息
        },
        name: '',
        cardNumber: '',
        subbranch: '',//支行
        bankAddress: '',//银行地址
        timeout: null,
        cardMes: {},
        completeApi: true, //获取银行卡的接口是否获取完成
        errorMessage: '', //卡号错误提示
      }
    },
    methods:{
      //监听卡号变化，防抖获取银行卡信息
      changeNum() {
        this.completeApi = false;
        if(this.timeout !== null)   clearTimeout(this.timeout);        
        this.timeout = setTimeout(() => {
          this.getCardInfo()
        }, 300);    
      },
      //获取银行卡信息
      getCardInfo() {
        axios.get('https://ccdcapi.alipay.com/validateAndCacheCardInfo.json',{
          params: {
            _input_charset: 'utf-8',
            cardNo: this.cardNumber,
            cardBinCheck:true
          }
        })
          .then(res => {
            this.completeApi = true;
            if (res.data.validated && res.data.bank) { //匹配到银行信息
              this.cardMes = res.data;
              this.cardMes.bankname = bankname[res.data.bank];
              this.cardMes.bankType = cardTypeMap[res.data.cardType]
              this.display.showBankMeg = true;
              this.errorMessage = '';
            }else{
              this.cardMes = {};
              this.display.showBankMeg = false;
              this.errorMessage = '无法识别您的卡号，请填写正确的银行卡卡号';
            }
          })
      },
      //添加银行卡
      addCard() {
        if(!this.completeApi)return
        if(!this.subbranch || !this.bankAddress || !this.name) {
          Toast('请将信息填写完整')
          return
        }
        const params = {
          realName: this.name,
          cardNo: this.cardNumber,
          bankName: this.cardMes.bankname,
          cardType: this.cardMes.cardType,
          subbranch: this.subbranch,
          bankAddress: this.bankAddress
        }
        api.addBankCard(params)
          .then(res => {
            Toast.success('添加成功')
            this.$router.push({
              name: 'bankCard'
            })
          })
          .catch(() => {
            Toast.fail('添加失败')
          })
      }
    }
  }
</script>
<style lang='scss' scoped>
  .add-card-btn-box{
    display: flex;
    justify-content: center;
    margin: 100px;
  }
</style>